import React, { useEffect } from 'react'

function Social(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
    <h1>{props.title}</h1>
      
      <div id="social">
        <h2>Subscribe To Me</h2>
        <p>You can find me on YouTube <a href="https://www.youtube.com/channel/UCCVeSCzDOyh9yGgSemkHVag">here!</a></p>
        <div class="bottom-space"><br /></div>
      </div>
    </main>
  )
}

export default Social